// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './context/UserContext';
// import { GoogleOAuthProvider } from '@react-oauth/google';

// const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// if (!GOOGLE_CLIENT_ID) {
//   console.error("REACT_APP_GOOGLE_CLIENT_ID não está definido no .env");
// }

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/* <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}> */}
      <UserProvider>
        <App />
      </UserProvider>
    {/* </GoogleOAuthProvider> */}
  </React.StrictMode>
);

reportWebVitals();
